import HelpContentLayout from './HelpContentLayout';
import HelpContentBlock from './HelpContentBlock';

export default function TeamsHelpContent({ close }) {
  const list = [
    { img: 'brain', text: 'Create cards for a front man' },
    {
      img: 'money',
      text: 'Conduct questionable transactions from the point of view of the tax service',
    },
    { img: 'boring', text: 'Leading a carefree life' },
  ];

  return (
    <HelpContentLayout close={close}>
      <div className="helpContent">
        {list.map((item, index) => (
          <HelpContentBlock
            key={item.img}
            index={index}
            img={item.img}
            text={item.text}
          />
        ))}
      </div>
    </HelpContentLayout>
  );
}
